import { useQuery } from "@tanstack/react-query";
import { api } from "../../config";

function useAuthLogin(data, exec) {
    return useQuery({
        queryFn: async () => {
            const res = await api.post(`/auth/login`, data);
            return res.data;
        },
        queryKey: ['auth-login', exec], // Usando apenas exec como dependência para nova requisição
        enabled: exec,
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 0
    })
}

export {
    useAuthLogin
}

/*
 controle - states
  -> local (useState)
  -> global (lib)
  -> http (react-query)
*/